import { render, staticRenderFns } from "./DarkModeSwitch.vue?vue&type=template&id=3258491a"
import script from "./DarkModeSwitch.vue?vue&type=script&lang=js"
export * from "./DarkModeSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports